var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "offer-list"
  }, _vm._l(_vm.list, function (offer, index) {
    return _c('ProductOffer', {
      key: offer.title,
      attrs: {
        "offer": offer,
        "path": _vm.path
      },
      on: {
        "change": function ($event) {
          return _vm.onOfferChange($event, index);
        }
      }
    });
  }), 1);
}
var staticRenderFns = []

export { render, staticRenderFns }